"use client";
import React, { useEffect } from "react";
import SectionHeading from "../shared/SectionHeading";
import Check from "../../assets/course-details/other/Check.svg";
import FeeDetailsBg from "../../assets/course-details/other/FeeDetailsBg.svg";

const FeeDetails = ({ data }) => {
  useEffect(() => {
    // console.log("data" , data)
  });
  if (!data.section[11].isActive) {
    return <div></div>;
  }

  return (
    <>
   <div className="relative bg-gradient-to-r from-[#FF99000D] to-[#04236B0D] py-12 px-4 md:px-8 lg:px-16">
  <SectionHeading>
    <span className="text-primary-color">Fee</span>{" "}
    <span className="text-secondary-color">Details</span>
  </SectionHeading>

  <div className="flex flex-col-reverse lg:flex-row justify-center items-center gap-6 lg:gap-16 py-10">
    
    {/* Left Box */}
    <div className="relative w-full max-w-[26rem] p-6 bg-white rounded-xl shadow-xl border border-gray-200">
      {/* Corner borders */}
      <div className="absolute top-0 left-0 w-6 h-6 border-t-[5px] border-l-[5px] border-yellow-400 rounded-tl-xl"></div>
      <div className="absolute bottom-0 right-0 w-6 h-6 border-b-[5px] border-r-[5px] border-yellow-400 rounded-br-xl"></div>

      {/* Title */}
      <div className="text-[1.6em] font-semibold text-center lg:text-left mb-3">
        <h3 className="text-secondary-color">{data.section[11].body.subtitle}</h3>
        <h3 className="text-primary-color">{data.section[11].body.content1}</h3>
      </div>

      {/* Description */}
      <div className="py-3 text-gray-600 text-center lg:text-left text-[15px]">
        {data.section[11].body.content2}
      </div>

      {/* List */}
      <div className="mt-4 space-y-2">
        <div className="mb-2 text-gray-600 text-sm">
          {data.section[11].body.content3}
        </div>
        {data.section[11].body.list1.map((item, index) => (
          <div key={index} className="flex items-start gap-3">
            <img src={Check} alt="Check" width={20} height={20} />
            <p className="text-gray-700 text-sm">{item.text}</p>
          </div>
        ))}
      </div>

      {/* Button */}
      <div className="flex justify-center lg:justify-start pt-6">
        <button className="text-white text-sm font-semibold bg-primary-color px-8 py-2 rounded-md shadow hover:bg-primary-dark transition-all">
          Apply Now
        </button>
      </div>
    </div>

    {/* Right Image */}
    <div className="flex justify-center items-center lg:pl-10">
      <div className="relative">
        <img
          src={FeeDetailsBg}
          alt="Fee Details"
          className="max-w-[280px] md:max-w-[380px] rounded-xl drop-shadow-md"
        />
        <div className="absolute top-0 left-0 w-full h-full rounded-xl bg-white/10 hover:bg-white/20 transition-all"></div>
      </div>
    </div>
  </div>
</div>

</>
  );
};

export default FeeDetails;
